

export const MESSAGE = 'MESSAGE';
export const MESSAGE5 = 'MESSAGE5';

export const LOGGEDIN = 'LOGGEDIN';
export const RIGHTS = 'RIGHTS';
export const ROLE = 'ROLE';
export const ADVERTISER = 'ADVERTISER';
export const PRODUCER = 'PRODUCER'
export const DISTRIBUTOR = 'DISTRIBUTOR';
export const LOADING_TOGGLE_ACTION = "LOADING_TOGGLE_ACTION";
// export const SUBADMIN = "SUBADMIN"
export const PROFILE = 'PROFILE';
export const DARKMODE = "DARKMODE"

// Top 10 video
export const TOP_TEN_VIDEOS = 'TOP_TEN_VIDEOS'



// Masters
export const CATEGORIES = 'CATEGORIES'
export const SUBCATEGORIES= 'SUBCATEGORIES'
export const SONGCATEGORIES= 'SONGCATEGORIES'
export const CASTS= 'CASTS'
export const GENRE= 'GENRE'
export const LANGUAGES= 'LANGUAGES'
export const DISTRIBUTORS= 'DISTRIBUTORS'
export const DISTRIBUTORS_FORM_LIST= 'DISTRIBUTORS_FORM_LIST'
export const PRODUCERS= 'PRODUCERS'
export const SUBADMINS= 'SUBADMINS'
export const MODULES= 'MODULES'
export const AVATARS = "AVATARS"
export const COUNTRIES = "COUNTRIES"
export const ADVISORY = "ADVISORY"
export const PAYMENTGATEWAY = "PAYMENTGATEWAY"
export const OTTNAME = "OTTNAME"
export const SUBOTT = "SUBOTT"
export const COMPLAINT_TYPE = "COMPLAINT_TYPE"

// Coming Soon
export const COMINGSOON = "COMINGSOON"

//Song
export const SONG_LIST = "SONG_LIST" 
export const SONG_WATCH_USER = "SONG_WATCH_USER" 
export const SONG_DETAIL = "SONG_DETAIL" 
export const SONG_NAME_LIST = "SONG_NAME_LIST" 

// Subscription
export const SUBSCRIPTIONS = 'SUBSCRIPTIONS'
// Demands
export const DEMANDS = "DEMANDS"

//Reports
export const REPORTS = "REPORTS" 

//Bank Details
export const BANKDETAILS = "BANKDETAILS"
export const BANKDETAILCREATE = "BANKDETAILCREATE"
export const BANKDETAILSLIST = "BANKDETAILSLIST"

export const MESSAGEOTP = "MESSAGEOTP"
export const MESSAGEOTPVERIFY = "MESSAGEOTPVERIFY"

//Payment

export const RAZORPAYRES ="RAZORPAYRES"

// Advertisement
export const ADVERTISEMENTS = "ADVERTISEMENTS"
export const ADPAYMENT="ADPAYMENT"
export const ADPAY = "ADPAY"
export const SETAD = "SETAD"
export const ADDELETE = "ADDELETE"

// Customer
export const CUSTOMERS = "CUSTOMERS"
export const CUSTOMER = "CUSTOMER"
export const PREMIUMCUSBYPLAN = "PREMIUMCUSBYPLAN"
export const PREMIUMCUSBYRENT = "PREMIUMCUSBYRENT"
export const CUSTOMERLOADING = "CUSTOMERLOADING"



// Live Streaming
export const TV_CATEGORIES = "TV_CATEGORIES"
export const TV_CHANNELS = "TV_CHANNELS"

//Current
export const CURRENTTIME = "CURRENTTIME" 

// Merchandise
export const COUPONS = "COUPONS"
export const COUPONHISTORY = "COUPONHISTORY"
export const NOTIFICATIONS = "NOTIFICATIONS"
export const NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT"
export const NOTIFICATION_READ = "NOTIFICATION_READ"
export const SLIDER_BANNERS = "SLIDER_BANNERS"
export const PSSLIDER_BANNERS = "PSSLIDER_BANNERS"
export const SONG_SLIDER_BANNERS = "SONG_SLIDER_BANNERS"
export const NOTIFICATION_MASK = "NOTIFICATION_MASK"
export const NOTIFICATION_DISTRIBUTOR = "NOTIFICATION_DISTRIBUTOR"
export const COUPONS_MOVIE = "COUPONS_MOVIE"
export const COUPONS_SERIES = "COUPONS_SERIES"

// Movie
export const MOVIES = "MOVIES"
export const PSMOVIES = "PSMOVIES"
export const MOVIE = "MOVIE"
export const UPCOMING_MOVIES = "UPCOMING_MOVIES"
export const MOVIE_WATCH_USER = "MOVIE_WATCH_USER"
export const MOVIE123 = "MOVIE123"
export const SUBTITLEDELETE = "SUBTITLEDELETE"
export const AUDIOFILEDELETE = "AUDIOFILEDELETE"
export const MOVIENAMELIST = "MOVIENAMELIST"
export const MOVIELISTLOADING = "MOVIELISTLOADING"

//Offer
export const OFFER = "OFFER"

//Ad Banner
export const ADBANNER = "ADBANNER"
 

// Report
export const PPV_CUSTOMERS = "PPV_CUSTOMERS"
export const REGISTERED_CUSTOMERS = "REGISTERED_CUSTOMERS"
export const SUBSCRIBED_CUSTOMERS = "SUBSCRIBED_CUSTOMERS"

// Transaction
export const TRANSACTIONS = "TRANSACTIONS"
export const TRANSACTIONSLOADING = "TRANSACTIONSLOADING"

// Watchhours
export const WATCHHOURS = "WATCHHOURS"

//Promotion

export const PROMOTION = "PROMOTION"

//Highlight

export const HIGHLIGHT = "HIGHLIGHT"

//Content Form
export const CONTENT_FORM = "CONTENT_FORM"
export const DISTRIBUTOR_MOVIE = "DISTRIBUTOR_MOVIE"
export const DISTRIBUTOR_SERIES = "DISTRIBUTOR_SERIES"
export const DISTRIBUTOR_SONG = "DISTRIBUTOR_SONG"
export const DISTRIBUTOR_PROMOCODE = "DISTRIBUTOR_PROMOCODE"

// Web Series
export const EPISODES = "EPISODES"
export const EPISODE = "EPISODE"
export const SERIES = "SERIES"
export const SEASONS = "SEASONS"
export const SEASONS_NAME = "SEASONS_NAME"
export const EPISODE_WATCH_USER = "EPISODE_WATCH_USER"
export const EPISODE_LIST_LOADING = "EPISODE_LIST_LOADING"
export const EPSUBTITLEDELETE = "EPSUBTITLEDELETE"
export const EPAUDIOFILEDELETE = "EPAUDIOFILEDELETE"
export const SERIESDETAILS = "SERIESDETAILS"
export const SERIESNAME = "SERIESNAME"
export const SERIES_LIST_LOADING = "SERIES_LIST_LOADING"
// Produce Form

export const PRODUCERFORMDATA = "PRODUCERFORMDATA"
export const PRODUCERFORMDETAILS = "PRODUCERFORMDETAILS"

// Setting
export const ABOUTUS = "ABOUTUS"
export const PRIVACYPOLICY = "PRIVACYPOLICY"
export const TERMSCONDITIONS = "TERMSCONDITIONS"
export const REFUNDPOLICY = "REFUNDPOLICY"
export const APPSETTING = "APPSETTING"
export const LOGS = "LOGS"
export const LOGSDEC = "LOGSDEC"
export const USER_SUB = "USER_SUB"

// Dashboard
export const TOTALUSERS = "TOTALUSERS"
export const DASHBOARDCOUNT = "DASHBOARDCOUNT"
export const DASHBOARDMOVIES = "DASHBOARDMOVIES"
export const TOTALSUBSCRIBEUSER = "TOTALSUBSCRIBEUSER"
export const MONTHLYREVENUE = "MONTHLYREVENUE"
export const TOTALREVENUE = "TOTALREVENUE"
export const TV_SHOW_DASHBOARD = "TV_SHOW_DASHBOARD"
export const RECENT_SUBSCRIBER_DASHBOARD = "RECENT_SUBSCRIBER_DASHBOARD"
export const DAILY_REVENUE = "DAILY_REVENUE"
export const MAX_LOGIN_DURATION = "MAX_LOGIN_DURATION"
export const RENEWAL = "RENEWAL"
export const PRODUCER_MOVIE_GRAPH = "PRODUCER_MOVIE_GRAPH"
export const ADVERTISEMENT_VIEW_GRAPH = "ADVERTISEMENT_VIEW_GRAPH"
export const PRODUCER_MOVIE_LIST = "PRODUCER_MOVIE_LIST"
export const REGION_CHART = "REGION_CHART"
export const MOST_WATCH_MOVIE = "MOST_WATCH_MOVIE"

export const HIGHESTMOVIECOUNT = "HIGHESTMOVIECOUNT"
export const TOTALREVENUEDIS = "TOTALREVENUEDIS"

// Distributor
export const DIS_MOST_WATCH_MOVIE = "DIS_MOST_WATCH_MOVIE"
export const DIS_MOST_WATCH_SERIES = "DIS_MOST_WATCH_SERIES"
export const DIS_MOST_WATCH_SONG = "DIS_MOST_WATCH_SONG"
export const DIS_REVENUE_WATCH_MOVIE = "DIS_REVENUE_WATCH_MOVIE"
export const DIS_REVENUE_WATCH_SERIES = "DIS_REVENUE_WATCH_SERIES"
export const DIS_REVENUE_WATCH_SONG = "DIS_REVENUE_WATCH_SONG"
export const DIS_DASHBOARD_COUNT = "DIS_DASHBOARD_COUNT"


// Complaint
export const COMPLAINTS = "COMPLAINTS"

//Content Leaving Soon
export const CONTENT_LEAVING_SOON = "CONTENT_LEAVING_SOON"

//Advertisors
export const ADVERTISERS = "ADVERTISERS"
export const ADPAYMENTLIST = "ADPAYMENTLIST"
export const ADFORMDETAILS = "ADFORMDETAILS"

//Analytics
export const HIGHEST_WATCHED_MOVIES_GRAPH ="HIGHEST_WATCHED_MOVIES_GRAPH"
export const LOWEST_WATCHED_MOVIES = "LOWEST_WATCHED_MOVIES"
export const HIGHEST_WATCHED_SERIES_GRAPH ="HIGHEST_WATCHED_SERIES_GRAPH"
export const LOWEST_WATCHED_SERIES = "LOWEST_WATCHED_SERIES"
export const HIGHEST_WATCHED_SONG_GRAPH ="HIGHEST_WATCHED_SONG_GRAPH"
export const LOWEST_WATCHED_SONG = "LOWEST_WATCHED_SONG"
export const HIGHEST_SEARCHED_MOVIES_GRAPH = "HIGHEST_SEARCHED_MOVIES_GRAPH"
export const CURRENTLY_LOGGED_IN_USERS = "CURRENTLY_LOGGED_IN_USERS"
export const CURRENTLY_LOGGED_IN_USERS_BY_STATE_GRAPH = "CURRENTLY_LOGGED_IN_USERS_BY_STATE_GRAPH"
export const CURRENTLY_WATCHING_USERS = "CURRENTLY_WATCHING_USERS"
export const DEVICE_USED_FOR_WATCHING = "DEVICE_USED_FOR_WATCHING"
export const AREA_WISE_AD_VIEW = "AREA_WISE_AD_VIEW"

export const CUSTOMERLOADINGSEARCH = "CUSTOMERLOADINGSEARCH"
export const ADDCREDIT = "ADDCREDIT"
export const CREDITHISTORY = "CREDITHISTORY"
export const CREDITHISTORYPLAN = "CREDITHISTORYPLAN"





